module.exports = __webpack_public_path__ + "static/media/icon-pets-full.0ecfce7c.png";